import { call, put, takeLatest } from "redux-saga/effects";
import { ToastError, ToastInfo, ToastSuccess } from "components/Global/Toasts/Toasty";
import {
  uploadFile,
  downloadXLSFile,
  downloadFile,
  authorizedRequest
} from "utils/api";
import {
  defaultReturn
  , multipleObjectReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , handleCallback
  , subKeySaga
} from "shared-utility/store/utils/helpers";

// ACTIONS
export const CASHFLOW_TEST_HARNESS_GENERATE_CASHFLOWS = generateDefaultActions("CASHFLOW_TEST_HARNESS_GENERATE_CASHFLOWS");
export const generateCashflows = payload => makePayload(CASHFLOW_TEST_HARNESS_GENERATE_CASHFLOWS.value, payload);
function* generateCashflowsSaga(payload) {
  const callback = handleCallback(payload);
  const url = "/generateCashflows";
  ToastInfo("Generating Cashflows...");
  yield requestSaga(CASHFLOW_TEST_HARNESS_GENERATE_CASHFLOWS, url, "POST", payload);
  yield callback();
}

export const CASHFLOW_TEST_HARNESS_GET_CONFIG_ITEMS = generateDefaultActions("CASHFLOW_TEST_HARNESS_GET_CONFIG_ITEMS");
export const getConfigItems = payload => makePayload(CASHFLOW_TEST_HARNESS_GET_CONFIG_ITEMS.value, payload);
function* getConfigItemsSaga(payload) {
  const url = "/getCashflowConfigItems";
  yield requestSaga(CASHFLOW_TEST_HARNESS_GET_CONFIG_ITEMS, url, "GET");
}

export const CASHFLOW_TEST_HARNESS_DOWNLOAD_CASHFLOWS = generateDefaultActions("CASHFLOW_TEST_HARNESS_DOWNLOAD_CASHFLOWS");
export const downloadCashflows = payload => makePayload(CASHFLOW_TEST_HARNESS_DOWNLOAD_CASHFLOWS.value, payload);
function* downloadCashflowsSaga(payload) {
  yield call(downloadFile, "downloadCashflows", "POST", payload);
}

// REDUCER
const initialState = {
  cashflows: [],
  numberOfLegs: 1,
  configItems: {}
};

export function cashflowTestHarnessReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case CASHFLOW_TEST_HARNESS_GENERATE_CASHFLOWS.success:
      return multipleObjectReturn(state, ["cashflows", "numberOfLegs"], [payload.cashflows, payload.numberOfLegs]);

    case CASHFLOW_TEST_HARNESS_GET_CONFIG_ITEMS.success:
      return defaultReturn(state, payload, "configItems");

      // DEFAULT
    default:
      return defaultReturn(state);
  }
}

// SAGA

export function* cashflowTestHarnessSaga() {
  yield takeLatest(CASHFLOW_TEST_HARNESS_GENERATE_CASHFLOWS.value, generateCashflowsSaga);
  yield takeLatest(CASHFLOW_TEST_HARNESS_GET_CONFIG_ITEMS.value, getConfigItemsSaga);
  yield takeLatest(CASHFLOW_TEST_HARNESS_DOWNLOAD_CASHFLOWS.value, downloadCashflowsSaga);
}
